import * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { ThreadVisibility } from "@/shared/domain/agents";
import { FormSection, Radio, RadioGroup } from "@/shared/foundation/primitives";

import { type LaunchFormValues } from "../launchFormSchema";

export interface VisibilitySectionProps {
  /** The current org's name, for the choice that shares the thread with it. */
  orgName?: string;
}

/** Whether the new thread is the org's to read, or its launcher's alone. */
export function VisibilitySection({ orgName }: VisibilitySectionProps) {
  const { control } = useFormContext<LaunchFormValues>();
  const titleId = React.useId();

  return (
    <FormSection title="Who can see this thread" titleId={titleId}>
      <div data-testid="launch-visibility">
        <Controller
          control={control}
          name="visibility"
          render={({ field }) => (
            <RadioGroup<ThreadVisibility>
              appearance="card"
              size="md"
              aria-labelledby={titleId}
              value={field.value}
              onValueChange={field.onChange}
            >
              <Radio
                value={ThreadVisibility.ORG}
                label={"Everyone in this org"}
                description={`Everyone in ${orgName} can view the agent's threads.`}
              />
              <Radio
                value={ThreadVisibility.PRIVATE}
                label="Only you"
                description="Only you can read it."
              />
            </RadioGroup>
          )}
        />
      </div>
    </FormSection>
  );
}
